import { resetPassword } from 'services/session.service';
import { getPayments } from 'services/payment.service';
import {
    REQUESTED,
    FAILED,
    SUCCESSFUL,
    PAYMENT_HISTORY_REQUESTED,
    PAYMENT_HISTORY_FAILED,
    PAYMENT_HISTORY_SUCCESSFUL,
} from './actionTypes';

export function changePassword(currentPassword, password) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: REQUESTED,
    });
    resetPassword(currentPassword, password, (err) => {
      if (err) {
        dispatch({
          type: FAILED,
        });
      } else {
        dispatch({
          type: SUCCESSFUL,
        });
      }
    });
  };
}

export function getPaymentHistory(id) {
  return (dispatch) => {
    dispatch({
      type: PAYMENT_HISTORY_REQUESTED,
    });
    getPayments(id)
          .then((data) => {
            if (data) {
              dispatch({
                type: PAYMENT_HISTORY_SUCCESSFUL,
                result: data,
              });
            }
          })
          .catch((err) => {
            dispatch({
              type: PAYMENT_HISTORY_FAILED,
              error: err,
            });
          });
  };
}



// WEBPACK FOOTER //
// ./src/containers/Settings/actions.js